import { Component, EventEmitter, HostBinding, Input, Output, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'sag-ui-tab',
    template: `<div sag-ui-tabs-tab [active]="active" [disabled]="disabled" (click)="click.emit(value)">
            <span>{{ label }}</span>
        </div>
        <ng-template #tabContentTemplate>
            <ng-content></ng-content>
        </ng-template>`
})
export class TabComponent {
    @Input() active: boolean;
    @Input({ required: true }) label: string;
    @Input() disabled: boolean;
    @Input() value: string | number;

    @HostBinding('attr.role') role = 'listitem';
    @HostBinding('class') className = 'tab-item';
    @HostBinding('name') tagName = 'LI';

    @ViewChild('tabContentTemplate') tabContentTemplate: TemplateRef<any>;

    // eslint-disable-next-line @angular-eslint/no-output-native
    @Output() click: EventEmitter<string | number> = new EventEmitter();
}
